/* eslint-disable */

import Api from '@/repository/index'
import { Message } from 'element-ui'

const state = {
  data: [],
  accesses: [],
  accesses_splitted: []
}

const mutations = {
  SET: (state, data) => {
    state.data = data
  },
  SET_ACC: (state, data) => {
    state.accesses = data
  },
  SET_ACC_SP: (state, data) => {
    state.accesses_splitted = data
  },
  REMOVE: (state, id) => {
    state.data = state.data.filter(cur => cur.id !== id)
  },
  ADD: (state, data) => {
    state.data.push(data)
  },
  UPDATE_ROLE: (state, id) => {
    //  FIX
  }
}

const actions = {
  async getRolesAccesses ({ commit, state }) {
    try {
      const response = await Api.roles.getRolesAccesses()
      commit('SET_ACC', response)
      return response
    } catch (err) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },

  async getAccessesSplitted ({ commit, state }) {
    try {
      const response = await Api.roles.getAccessesSplitted()
      commit('SET_ACC_SP', response)
      return response
    } catch (err) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },

  async updateRole ({ commit, state }, data) {
    try {
      const response = await Api.roles.updateRole(data)
      Message({
        message: 'Информация о роли была изменена',
        type: 'success',
        duration: 5 * 1000
      })
      return response
    } catch (err) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },
  async createRole ({ commit, rootGetters }, data) {
    try {
      const response = await Api.roles.createRole({ ...data, parkId: rootGetters['userStore/getActualPark']().id })
      commit('ADD', response)
      Message({
        message: 'Роль была добавлена',
        type: 'success',
        duration: 5 * 1000
      })
      return response
    } catch (err) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },
  async getRoleById ({ commit, state }, id) {
    return state.data.find(x => x.id === id)
  },
  fetch ({ commit, rootGetters }) {
    return Api.roles.getRolesByParkId(rootGetters['userStore/getActualPark']().id)
      .then(data => {
        commit('SET', data)
        return data
      })
      .catch((error) => {
        return error
      })
  },

  remove ({ commit }, id) {
    return new Promise((resolve, reject) => {
      Api.roles.deleteRoleById(id).then(() => {
        commit('REMOVE', id)
        Message({
          message: 'Роль была удалена',
          type: 'success',
          duration: 5 * 1000
        })
        resolve(id)
        return id
      }).catch(error => {
        Message({
          message: 'Ошибка',
          type: 'error',
          duration: 5 * 1000
        })
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
